import React from "react";
import styles from "./LFE.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Mixing.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const LFE: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs controlsPosition="bottom">
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.lfeSlideTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.lfeSlideDescription) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.lfeSlideTitle2)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.lfeSlideDescription2) }}></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
